export default __webpack_public_path__ + "static/media/ToyotaFavicon.3ea8b4ac.ico";